import React, { useState, useEffect, useCallback } from "react";
import { db, storage, admin } from "../../../firebase";

// Icons
import { Close } from "@mui/icons-material";

// Components
import BackdropLoader from "../../Loaders/BackdropLoader";
import ErrorModal from "../../ErrorModal/ErrorModal";
import ClubSponsor from "../../../pages/Clubs/Sponsors/ClubSponsor";
import PageHeader from "../../display/Rows/PageHeader";
import BackRow from "../../display/Rows/BackRow";
import { Dialog } from "@mui/material";
import Pill from "../../Buttons/Pill";
import { useDropzone } from "react-dropzone";
import Compressor from "compressorjs";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { successIco } from "../../ClientStats/HelperFunctions";

function LeagueSponsorManager({
  leagueID = "",
  teamLeague = false,
  goBack = () => {},
}) {
  // State
  const [loading, setLoading] = useState(true);
  const [clubID, setClubID] = useState("");
  const [error, setError] = useState("");
  const [clubSponsors, setClubSponsors] = useState([]);
  const [leagueSponsors, setLeagueSponsors] = useState([]);
  const [showNew, setShowNew] = useState(false);

  const [update, setUpdate] = useState(0);

  const [sponsorIDs, setSponsorIDs] = useState([]);

  const [image, setImage] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [link, setLink] = useState("");
  const [sponsorName, setSponsorName] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    const url = URL.createObjectURL(acceptedFiles[0]);
    setImageURL(url);
    new Compressor(acceptedFiles[0], {
      convertSize: 1000000,
      success: (res) => {
        setImage(res);
      },
    });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
  });

  useEffect(() => {
    load();
  }, []);

  async function load() {
    let leagueDoc;
    if (teamLeague) {
      leagueDoc = await db.collection("teamLeagues").doc(leagueID).get();
    } else {
      leagueDoc = await db.collection("leagues").doc(leagueID).get();
    }
    const league = leagueDoc.data();
    const { clubID } = league;
    console.log(clubID);
    setClubID(clubID);
    const clubDoc = await db.collection("clubs").doc(clubID).get();
    const club = clubDoc.data();
    const leagueSponsors = league.sponsors ?? [];
    const sponsorIDs = leagueSponsors.map((spon) => spon.sponsorID);
    setSponsorIDs(sponsorIDs);

    setClubSponsors(club.sponsors ?? []);
    setLeagueSponsors(league.sponsors ?? []);
    setLoading(false);
  }

  async function saveChanges() {
    setLoading(true);
    const type = teamLeague ? "teamLeagues" : "leagues";
    try {
      await db.collection(type).doc(leagueID).update({
        sponsors: leagueSponsors,
      });
      toast.success("Changes successfully saved", {
        icon: successIco,
      });
      goBack();
    } catch (err) {
      console.log(err);
      setError(
        "Sorry - we encountered a technical difficulty there, please try again."
      );
    }
    setLoading(false);
  }

  async function saveSponsor() {
    setLoading(true);
    setShowNew(false);

    const task = storage.ref().child(`${clubID}/${image.name}`).put(image);

    const type = teamLeague ? "teamLeagues" : "leagues";

    console.log(type, clubID, leagueID);

    try {
      await task.then(async (snapshot) => {
        await snapshot.ref.getDownloadURL().then(async (url) => {
          const newSponsor = {
            imageLink: url,
            sponsorName,
            link,
            sponsorID: uuid(),
          };
          await db
            .collection("clubs")
            .doc(clubID)
            .update({
              sponsors: admin.firestore.FieldValue.arrayUnion(newSponsor),
            });
          await db
            .collection(type)
            .doc(leagueID)
            .update({
              sponsors: admin.firestore.FieldValue.arrayUnion(newSponsor),
            });
          setSponsorName("");
          setImage("");
          setImageURL("");
          setLink("");
          setClubSponsors((current) => [...current, newSponsor]);
          setLeagueSponsors((current) => [...current, newSponsor]);
          toast.success("Sponsor successfully added", {
            icon: successIco,
          });
        });
      });
    } catch (err) {
      console.log(err);
      setError(
        "Sorry - we encountered a technical difficulty there, please try again"
      );
    }

    setLoading(false);
  }

  return (
    <div className="league-sponsor-manager event-sponsor-manager">
      <BackRow action={goBack} /> {loading && <BackdropLoader />}
      <Dialog open={showNew} onClose={() => setShowNew(false)}>
        <div className="new-sponsor">
          <div className="page-header">
            <h2>New Sponsor</h2>
            <Close onClick={() => setShowNew(false)} className="icon-cursor" />
          </div>
          <div className="ec-box">
            <div className="ig-group">
              <div className="input-group">
                <p>Sponsor Name</p>
                <input
                  type="text"
                  placeholder="Enter sponsor name..."
                  value={sponsorName}
                  onChange={(e) => setSponsorName(e.target.value)}
                  className="default-input"
                />
              </div>
              <div className="input-group">
                <p>Online Link</p>
                <input
                  type="url"
                  placeholder="Enter link..."
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                  className="default-input"
                />
              </div>
            </div>

            <div className="input-group mb-20">
              <p>Sponsor Picture</p>
              <div className="image-buttons">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className="dz-sel">
                    {imageURL !== "" && (
                      <div className="event-img">
                        <img className="" alt="profile" src={imageURL} />
                      </div>
                    )}
                    {imageURL === "" && (
                      <h5>
                        Drag 'n' drop an image here, or click to open up the
                        file explorer
                      </h5>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-center mb-40">
            <button
              onClick={saveSponsor}
              disabled={imageURL === "" || sponsorName === ""}
              className="default-button"
            >
              Save
            </button>
          </div>
        </div>
      </Dialog>
      <PageHeader text="Sponsor Manager" />
      <div className="ph-msg">
        <p>Select your sponsor(s) for this league</p>
      </div>
      {error !== "" && <ErrorModal hide={() => setError("")} text={error} />}
      {clubSponsors.length === 0 && (
        <div className="no-msg">
          <p>No sponsors to display</p>
        </div>
      )}
      <div className="quick-links">
        <Pill onClick={() => setShowNew(true)} text={"New Sponsor"} />
      </div>
      <div className="pl-20 mt-20 mb-20">
        <button onClick={saveChanges} className="default-button">
          Save Changes
        </button>
      </div>
      <div className="sub-header">
        <h5>Available</h5>
      </div>
      {clubSponsors.length > 0 && (
        <div className="cs-box flex-wrapper">
          {clubSponsors.map((sponsor, index) => (
            <ClubSponsor
              sponsor={sponsor}
              select
              hideIcons
              active={sponsorIDs.includes(sponsor.sponsorID)}
              selectAction={() => {
                setLeagueSponsors((current) => {
                  if (sponsorIDs.includes(sponsor.sponsorID)) {
                    const filtered = current.filter(
                      (spo) => spo.sponsorID !== sponsor.sponorID
                    );
                    console.log(filtered);
                    return filtered;
                  } else {
                    current.push(sponsor);
                    console.log(current);
                    return current;
                  }
                });
                setSponsorIDs((current) => {
                  if (current.includes(sponsor.sponsorID)) {
                    const filtered = current.filter(
                      (item) => item !== sponsor.sponsorID
                    );
                    return filtered;
                  } else {
                    current.push(sponsor.sponsorID);
                    return current;
                  }
                });
                setUpdate((current) => current + 1);
              }}
              // deleteAction={() => {
              //   setToDelete(sponsor);
              //   setShowDelete(true);
              // }}
              // editAction={() => {
              //   setEditSponsorName(sponsor.sponsorName);
              //   setEditImageURL(sponsor.imageLink);
              //   setToEdit(sponsor);
              //   setShowEdit(true);
              // }}
              key={sponsor.sponsorID}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default LeagueSponsorManager;
